import React from 'react';
// import { Button } from 'react-bootstrap';
// import { faUpFromBracket } from '@fortawesome/pro-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './DeviceListTableRowOverlay.css';
import PropTypes from 'prop-types';
import {
  connectModalContainerContextToComponent,
} from '../../../../../../contexts/ModalContext/ModalContext';
import ArchiveDeviceButton from '../../../../ArchiveDeviceButton/ArchiveDeviceButton';
// import envConfig from '../../../../../../envConfig';

/* istanbul ignore next */
function DeviceListTableRowOverlay({
  deviceId, deviceName,
}) {
  return (
    <div className="row-popover-content" style={{ backgroundColor: 'rgba(242, 242, 242, 1.0)' }}>
      {/* <Button */}
      {/*   variant="link" */}
      {/*   className="text-muted" */}
      {/*   onClick={() => { */}
      {/*     window.location.href = `${envConfig.raaUrl}/devices/firmware/${deviceId}`; */}
      {/*   }} */}
      {/*   title="Update Firmware" */}
      {/* > */}
      {/*   <FontAwesomeIcon icon={faUpFromBracket} /> */}
      {/* </Button> */}
      <ArchiveDeviceButton
        deviceId={deviceId}
        deviceName={deviceName}
      />
    </div>
  );
}

DeviceListTableRowOverlay.propTypes = {
  deviceId: PropTypes.number.isRequired,
  deviceName: PropTypes.string.isRequired,
};
export default connectModalContainerContextToComponent(DeviceListTableRowOverlay);
